export default "__VITE_ASSET__Jgml$GpB__"